import { useState, useEffect } from 'react';

/**
 * Hook để kiểm tra media query - hỗ trợ responsive
 * @param {string} query Media query cần kiểm tra (ví dụ: '(max-width: 768px)')
 * @returns {boolean} Trạng thái của media query
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);
  
  useEffect(() => {
    // Tạo media query matcher
    const media = window.matchMedia(query);
    
    // Cập nhật trạng thái ban đầu
    setMatches(media.matches);
    
    // Tạo callback để cập nhật trạng thái khi media query thay đổi
    const listener = () => {
      setMatches(media.matches);
    };
    
    // Đăng ký listener
    media.addEventListener('change', listener);
    
    // Cleanup khi component unmount
    return () => {
      media.removeEventListener('change', listener);
    };
  }, [query]);
  
  return matches;
}
